/** 判断创单 store 是否属于 Stripe Hosted Checkout 回跳链路 */
export function isStripeCheckoutStore(store: string | undefined): boolean {
    return Boolean(store?.includes('STRIPE'));
}
